module.exports = __webpack_public_path__ + "img/2.473f4a4f.png";